import { render, staticRenderFns } from "./addPhoto.vue?vue&type=template&id=e9a06e20&scoped=true&"
import script from "./addPhoto.vue?vue&type=script&lang=js&"
export * from "./addPhoto.vue?vue&type=script&lang=js&"
import style0 from "./addPhoto.vue?vue&type=style&index=0&id=e9a06e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a06e20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
